import React from 'react'

const H3 = ({data, styleProps}) => {
  return (
    <h3 className={('n-paragraph-title pb-8p') + styleProps}>{data}</h3>
  )
}

export default H3